import PropTypes from 'prop-types';
import classNames from 'classnames';

const Container = ({ className, narrow, children, ...props }) => (
  <div
    className={classNames(
      'container',
      narrow && 'container--narrow',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

Container.propTypes = {
  className: PropTypes.string,
  narrow: PropTypes.bool,
  children: PropTypes.node,
};

export default Container;
